import React from 'react';

import Link from 'next/link';

import { useQuery } from 'react-query';
import { initService } from 'services/core';

import { useRouter } from 'next/router';

import GoogleButton from 'components/pages/auth/googlebutton/GoogleButton';
import FacebookButton from 'components/pages/auth/facebookbutton/FacebookButton';
import AppleButton from 'components/pages/auth/applebutton/AppleButton';
import LinkButton from '@core/components/linkbutton/LinkButton';

import classes from './LoginPrompt.module.scss';

import MoileTopHeadear from 'assets/images/getstarted-top.svg';

const LoginPrompt = () => {
	const { data: initData } = useQuery('app-init', initService);

	const router = useRouter();

	const onSuccess = () => {
		router.reload();
	};

	return (
		<>
			<div className={`${classes['loginprompt-wrapper']} d-flex flex-column align-items-center `}>
				<MoileTopHeadear />
				<div className={`${classes['loginprompt']} d-flex flex-column align-items-stretch`}>
					<h1>Register</h1>
					<p>
					Start learning and growing your career with Pharmuni!
					</p>
					<AppleButton
						hidden={!initData?.data?.oauth?.apple}
						callBack={onSuccess}
						nextPage={router.asPath}>
						Continue with Apple
					</AppleButton>
					<GoogleButton
						hidden={!initData?.data?.oauth?.google}
						callBack={onSuccess}
						nextPage={router.asPath}>
						Continue with Google
					</GoogleButton>
					<FacebookButton
						hidden={!initData?.data?.oauth?.facebook}
						callBack={onSuccess}
						nextPage={router.asPath}>
						Continue with Facebook
					</FacebookButton>
					<div className={`${classes['divider']}`}>or</div>
					<LinkButton
						className={`${classes['register-button']} d-flex align-items-center justify-content-center`}
						to="/register">
						Register with email
					</LinkButton>
					<p>
						Already registered? <Link href={`/login?next=${router.asPath}`}>Login</Link>
					</p>
				</div>
			</div>
		</>
	);
};

export default LoginPrompt;
